import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SiteContextState } from './site-context-state.type';

export const DP_SITE_CONTEXT_FEATURE = 'dpSiteContext';
export const siteContextFeatureSelector = createFeatureSelector<SiteContextState>(DP_SITE_CONTEXT_FEATURE);

export const countriesSelector = createSelector(siteContextFeatureSelector, ({ countries }) => countries);
export const languagesSelector = createSelector(siteContextFeatureSelector, ({ languages }) =>
  languages.map((language) => ({
    ...language,
    label: `${language?.nativeName} (${language?.isocode?.toUpperCase()})`
  }))
);

export const activeCountryCodeSelector = createSelector(
  siteContextFeatureSelector,
  ({ activeCountryCode }) => activeCountryCode
);
export const editBarVisibilitySelector = createSelector(
  siteContextFeatureSelector,
  ({ editBarVisibility }) => editBarVisibility
);

export const getMeasurementSystemEntities = createSelector(
  siteContextFeatureSelector,
  ({ measurementSystems }) => measurementSystems.entities
);

export const getActiveMeasurementSystem = createSelector(
  siteContextFeatureSelector,
  ({ measurementSystems }) => measurementSystems.activeMeasurementSystem
);

export const getAllMeasurementSystems = createSelector(getMeasurementSystemEntities, (entities) =>
  entities ? Object.keys(entities).map((isocode) => entities[isocode]) : null
);
